import styled from 'styled-components';
import { ToastContainer as OriginalToastContainer } from 'react-toastify';

const ToastContainer = styled(OriginalToastContainer).attrs({
  className: 'toast-container',
  role: 'alert',
  position: 'top-right',
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  pauseOnFocusLoss: false,
})`
  position: fixed;

  .Toastify__toast {
    align-items: center;
    margin: 10px;
    padding: 0;
    // min-height needs to be overwritten!
    min-height: 0;
    border: 1px solid #e5cdcd;
    border-radius: 4px;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  }

  .Toastify__toast-body {
    margin: 0 12px;
  }

  .Toastify__toast--rtl {
    padding: 0;
    margin: 0;
  }

  .Toastify__toast-icon {
    display: none;
  }

  .Toastify__close-button {
    align-self: auto;
    margin: 0 12px;
    color: #b91c1c;
  }

  .Toastify__toast--success .Toastify__close-button {
    color: #0369a1;
  }

  .Toastify__toast--error .Toastify__close-button {
    color: #b91c1c;
  }

  .Toastify__toast--success {
    background-color: #e0f2fe;
    color: #0369a1;
  }

  .Toastify__toast--error {
    background-color: #fee2e2;
    color: #b91c1c;
  }

  .Toastify__progress-bar--success {
    background-color: #3591e0;
  }
`;

export { ToastContainer };
